import { createSelector } from "reselect";
import { sectionsSelector } from "../../../sections_selector";

export const evaluationListBradenSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.evaluationListBraden;
  }
);
